/* @flow */
/* eslint-env es6,browser */

import _idpbase from './idpbase';
import { IDP_COMMONID } from './idpconstants';
import {
  getFromStore,
  saveToStore,
  removeFromStore
} from '../utils/storageutils';
import { generateUUID } from '../utils';
import { logError, logDebug } from '../utils/logger';

const COMMON_ID_KEY = '_pubcid';
const PUB_COMMON_ID = 'PublisherCommonId';

/**
 * @description Implements functionality accessing Publisher Common Id - http://prebid.org/dev-docs/modules/pubCommonId.html
 * @module commonid
 * @requires module:utils
 * @requires module:storage
 * @requires module:cookie
 */

class _commonid extends _idpbase {
  _loadFromCache(): boolean {
    if (this._cachedID.length === 0) {
      // no cached value
      let commonId = '';
      // if global pubcid module is included, let's use it.
      try {
        if (typeof window[PUB_COMMON_ID] === 'object') {
          commonId = window[PUB_COMMON_ID].getId();
        }
      } catch (error) {
        logError(`Error here ${error}`);
      }

      if (commonId.length === 0) {
        commonId = getFromStore(COMMON_ID_KEY, this._storage);
      }

      if (commonId.length > 0) {
        logDebug(`${this._name} retrieved ID from storage!`);
        this._cachedID = commonId;
        this._idUpdateTime = Date.now();
      }
    }
    return true;
  }

  _reset(): void {
    super._reset();
    // If the user has opted out then return empty id and remove existing pubcid
    removeFromStore(COMMON_ID_KEY, this._storage);
  }

  /**
   * @description Helper to common id of the user
   * @returns {string} - common id value
   */
  _refreshID() {
    // not available in storage. Let's generate and use it.
    const commonId = generateUUID();
    saveToStore(
      {
        name: COMMON_ID_KEY,
        value: commonId,
        doc: this._doc,
        expires: this._nExpireDays * 24 * 60 * 60
      },
      this._refreshInterval > 0,
      this._storage
    );
    logDebug(`${this._name} Generating ID and persisting in storage!`);
    this._cachedID = commonId;
  }
}

const cid: _commonid = new _commonid(IDP_COMMONID);
export default cid;
